import { assertNumber } from "common/assert";
import { constrain, remap } from "common/math";
import { delayAnimation } from "common/promises";
import log from "loglevel";
/**
 * 적어도 10초가 지나면 프로그레스 바가 꽉 찬다.
 */
const minimumSpeed = 0.1;
/**
 * 비디오 로딩 프로그레스를 가로채서 예쁘게 바꿈
 */
export class Video360LoadProgress {
    constructor() {
        this.startTime = Date.now();
        this.finished = false;
        this.lastProgress = 0;
    }
    overrideProgress(progress) {
        if (this.finished) {
            log.error("progress is called after finished");
            return this.lastProgress;
        }
        assertNumber(progress);
        const now = Date.now();
        const fromStartMillis = now - this.startTime;
        const minimumProgress = minimumSpeed * (fromStartMillis / 1000);
        this.lastProgress = Math.max(progress, minimumProgress);
        return this.lastProgress;
    }
    async makeFull(callback) {
        this.finished = true;
        const now = Date.now();
        const fromStartMillis = now - this.startTime;
        const minimumProgress = minimumSpeed * (fromStartMillis / 1000);
        if (minimumProgress >= 1) {
            callback(1);
            return;
        }
        const remainProgress = 1 - this.lastProgress;
        const durationFromMinimumSpeed = remainProgress / minimumSpeed;
        const maximumDuration = 3;
        const startTime = Date.now();
        const startProgress = this.lastProgress;
        const goalProgress = 1;
        const expectedEndTime = startTime + Math.min(durationFromMinimumSpeed, maximumDuration) * 1000;
        while (true) {
            await delayAnimation(1000 / 30);
            const now = Date.now();
            let progress = remap({
                start1: startTime,
                stop1: expectedEndTime,
                start2: startProgress,
                stop2: goalProgress,
                value: now,
            });
            progress = constrain({
                min: startProgress,
                max: goalProgress,
                value: progress,
            });
            callback(progress);
            if (now >= expectedEndTime) {
                return;
            }
        }
    }
}
//# sourceMappingURL=videoLoadProgress.js.map